import { memo } from 'react';
import StepPrefetch from './StepPrefetch';
import StepWithMaybeResponseView from './StepWithMaybeResponseView';

export type StepWithMaybeResponseProps = {
  responseIndex: number;
  isPinnedView?: boolean;
  collapsibleInstruction?: boolean;
  readOnly?: boolean;
  isCompletedTurnView?: boolean;
  disabledOpacity?: number;
  preventScrollToBottom?: boolean;
  inlineMode?: boolean;
  extractModelResponseRegex?: string;
};

function StepWithMaybeResponse({
  responseIndex,
  isPinnedView = false,
  collapsibleInstruction,
  readOnly,
  preventScrollToBottom,
  inlineMode = true,
  isCompletedTurnView,
  extractModelResponseRegex,
}: StepWithMaybeResponseProps) {
  return (
    <>
      <StepPrefetch responseIndex={responseIndex} />
      <StepWithMaybeResponseView
        responseIndex={responseIndex}
        isPinnedView={isPinnedView}
        collapsibleInstruction={collapsibleInstruction}
        readOnly={readOnly}
        preventScrollToBottom={preventScrollToBottom}
        inlineMode={inlineMode}
        isCompletedTurnView={isCompletedTurnView}
        extractModelResponseRegex={extractModelResponseRegex}
      />
    </>
  );
}
export default memo(StepWithMaybeResponse);
